module.exports = __webpack_public_path__ + "img/ELP.a1c32039.png";